import { Style, Icon } from 'ol/style'
import { PinType } from 'components/tools/ImpactoMap/types'

/* =========================================================
   🎨 CONFIG CENTRAL DE PIN TYPES
========================================================= */

export const PIN_TYPES: Record<PinType, { color: string; icon: string }> = {
  address: {
    color: '#A29BFE',
    icon: '🏠',
  },
  unified_person: {
    color: '#81ECEC',
    icon: '👤',
  },
  afacode: {
    color: '#74B9FF',
    icon: '🌍',
  },
  event: {
    color: '#FAB1A0',
    icon: '🎉',
  },
}

/* =========================================================
   🧩 SVG BASE DINÂMICO
========================================================= */

function generatePinSVG({
  color,
  icon,
  selected = false,
  hover = false,
}: {
  color: string
  icon: string
  selected?: boolean
  hover?: boolean
}) {
  // const circleRadius = selected ? 11 : 10
  const strokeWidth = selected ? 2 : 1.5
  // const glow = selected ? `filter="drop-shadow(0 0 6px ${color})"` : ''
  const circleRadius = selected ? 12 : hover ? 11 : 10
  const glow = selected
    ? `filter="drop-shadow(0 0 6px ${color})"`
    : hover
      ? `filter="drop-shadow(0 0 3px ${color})"`
      : ''

  return `
  <svg
    width="44"
    height="70"
    viewBox="0 0 44 70"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Agulha -->
    <line
      x1="22"
      y1="32"
      x2="22"
      y2="64"
      stroke="${color}"
      stroke-width="2"
      stroke-linecap="round"
    />

    <!-- Círculo -->
    <circle
      cx="22"
      cy="22"
      r="${circleRadius}"
      fill="${color}"
      stroke="white"
      stroke-width="${strokeWidth}"
      ${glow}
    />

    <!-- Ícone -->
    <text
      x="22"
      y="22"
      text-anchor="middle"
      dominant-baseline="central"
      font-size="12"
      fill="white"
      font-family="Arial, sans-serif"
    >
      ${icon}
    </text>
  </svg>
  `
}

function generateLabelPinSVG({
  color,
  text,
  selected = false,
  hover = false,
}: {
  color: string
  text: string
  selected?: boolean
  hover?: boolean
}) {
  const paddingX = 10
  const height = 24

  const approxCharWidth = 7
  const width = text.length * approxCharWidth + paddingX * 2

  const svgWidth = width + 20
  const centerX = svgWidth / 2

  const strokeWidth = selected ? 2 : 1.5

  const glow = selected
    ? `filter="drop-shadow(0 0 6px ${color})"`
    : hover
    ? `filter="drop-shadow(0 0 3px ${color})"`
    : ''

  const rectX = centerX - width / 2
  const rectY = 10

  return `
  <svg width="${svgWidth}" height="70" viewBox="0 0 ${svgWidth} 70" xmlns="http://www.w3.org/2000/svg">
    
    <!-- Agulha -->
    <line
      x1="${centerX}"
      y1="34"
      x2="${centerX}"
      y2="64"
      stroke="${color}"
      stroke-width="2"
      stroke-linecap="round"
    />

    <!-- Retângulo -->
    <rect
      x="${rectX}"
      y="${rectY}"
      width="${width}"
      height="${height}"
      rx="6"
      fill="${color}"
      stroke="white"
      stroke-width="${strokeWidth}"
      ${glow}
    />

    <!-- Texto -->
    <text
      x="${centerX}"
      y="${rectY + height / 2}"
      text-anchor="middle"
      dominant-baseline="central"
      font-size="12"
      fill="white"
      font-family="Arial, sans-serif"
    >
      ${text}
    </text>
  </svg>
  `
}

/* =========================================================
   🎯 STYLE FACTORY (ÚNICO PONTO DE ESTILO)
========================================================= */

export default function getPinStyle(
  type: PinType,
  options?: {
    selected?: boolean
    hover?: boolean
    variant?: 'default' | 'label'
    label?: string
  }
) {
  const config = PIN_TYPES[type]

  if (!config) {
    console.warn(`PinType "${type}" não configurado.`)
    return new Style()
  }

  let svg: string

  if (options?.variant === 'label') {
    svg = generateLabelPinSVG({
      color: config.color,
      text: options.label || '--------',
      selected: options?.selected,
      hover: options?.hover,
    })
  } else {
    svg = generatePinSVG({
      color: config.color,
      icon: config.icon,
      selected: options?.selected,
      hover: options?.hover,
    })
  }

  return new Style({
    image: new Icon({
      src: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg),

      anchor: options?.variant === 'label'
        ? [0.5, 1]
        : [20, 55],

      anchorXUnits: options?.variant === 'label' ? 'fraction' : 'pixels',
      anchorYUnits: options?.variant === 'label' ? 'fraction' : 'pixels',
    }),
  })
}
